import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { SpotifyListInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyRecommendProps {
  list: SpotifyListInfo;
}

const SpotifyRecommend: React.FC<SpotifyRecommendProps> = ({ list }) => {
  return (
    <div className="flex flex-col mx-4 mt-4 text-left mb-8">
      <div className="text-white font-bold">인기 급상승 추억 리스트</div>

      <HorizontalScrollableContainer>
        <div className="flex space-x-4 -ml-4">
          {list.titles.map((content, index) => (
            <div key={index} className="w-32 h-40">
              <img
                src={list.images[index]}
                alt={`Thumbnail ${index + 1}`}
                className="w-32 h-32 object-cover rounded-lg mb-1"
              />
              <div className="text-white font-bold text-md">
                {list.titles[index]}
              </div>
              <div className="text-gray-500 text-sm">
                {list.captions[index]}
              </div>
            </div>
          ))}
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default SpotifyRecommend;
